import { ActiveTab } from "../../ordersSetting/types";
import { IVenueGroup } from "./groupsManagement.reducer";


export const SET_VENUE_GROUPS = "SET_VENUE_GROUPS";

export const setVenueGroups = (data:IVenueGroup[]) => {
    return {
        type: SET_VENUE_GROUPS,
        payload: data
    };
};


export const SET_ACTIVE_TAB_STATE = "SET_ACTIVE_TAB_STATE";

export function setActiveTabState(activeTab:ActiveTab) {
    return {
        type: SET_ACTIVE_TAB_STATE,
        payload: activeTab
    };
}

export const SET_GROUP_DETAILS = "SET_GROUP_DETAILS";

export function setGroupDetails(group:IVenueGroup | undefined) {
    return {
        type: SET_GROUP_DETAILS,
        payload: group
    };
}
